<script lang="ts">
    
    import { onDestroy } from "svelte"; 
    import { fly } from "svelte/transition"; 
    import type { RealTimeEvent } from "../../global";
    import type { Player } from "../../Model/Player";
    import { eventsChannelFactory, i18nService, playersFactory } from "../../Services";    
    import type { EventsChannel } from "../../Services/EventsChannel";
    import Picture from "../Shared/Picture.svelte";
    import Watch from "../Shared/Watch.svelte";

    export let roomId: string;

    let roomEventsChannel: EventsChannel;
    let player: Player;
    let action: string;
    let actionClass: 'bg-invalid' | 'bg-success';

    $: setupEventsChannel(roomId);

    onDestroy(() => roomEventsChannel?.destroy());

    function setupEventsChannel(roomId: string): void {
        roomEventsChannel?.destroy();
        roomEventsChannel = eventsChannelFactory.createEventsChannel(`room.${roomId}`);
        roomEventsChannel.on('player_enter', onPlayerenter);
        roomEventsChannel.on('player_leave', onPlayerleave);
    }

    function onPlayerenter({ data }: RealTimeEvent): void {
        player = playersFactory.createPlayerFromDto(data.player);
        action = i18nService.getText('Ha entrado en la sala');
        actionClass = 'bg-success';
    }

    function onPlayerleave({ data }: RealTimeEvent): void {
        player = playersFactory.createPlayerFromDto(data.player);
        action = i18nService.getText('Ha salido de la sala');
        actionClass = 'bg-invalid';
    }

</script>

<div class="room-transit">
    {#if player}
        {#key player}
            <div class="player" in:fly={{ y: -50 }} out:fly={{ y: 50 }}>
                <div class="picture">
                    <Picture id={player.pictureId} />
                </div>
                <div class="info">
                    <div class="name">
                        <Watch state={player.name} />
                    </div>
                    <div class="action">
                        <div class="action-color {actionClass}"></div> {action}
                    </div>
                </div>
            </div>
        {/key}
    {/if}
</div>

<style lang="scss">

    .room-transit {
        height: 5rem;
        width: 100%;
        position: relative;
    }

    .player {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }

    .picture {
        position: relative;
        z-index: 2;
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        border: 2px solid #fff;
        overflow: hidden;
    }

    .info {
        flex: 1 1 0;
        height: 4rem;
        padding-left: 2rem;
        margin-left: -1rem;
        background-color: rgba(255, 255, 255, 0.2);
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
    }

    .name {
        font-family: Title;
        font-size: 1.4rem;
    }

    .action {
        font-size: 0.8rem;
    }

    .action-color {
        display: inline-block;
        width: 1em;
        height: 1em;
        border-radius: 50%;
        vertical-align: middle;
    }

</style>
